import { getCrossRequestDataOnce } from "#root/utility/cross-request-data";
import type { ReactNode } from "react";
import { useState } from "react";

import CreateAccountForm from "../components/create-account";
import PageLayout from "./layout";
import BackgroundHeader from "#root/components/background-header";

export default function (): ReactNode {
  const [initialData] = useState(getCrossRequestDataOnce());

  return (
    <PageLayout title="Contact Us">
      <BackgroundHeader>
        <div className="text-white w-full max-w-200 py-16">
          <h1 className="border-b-0 text-white text-4xl m-0">Thank You</h1>
          <p className="text-white text-xl my-[0.8rem]">We'll be in touch soon</p>
        </div>
      </BackgroundHeader>

      <section className="flex-none m-0 px-8 py-16 bg-[#f9f9fb]">
        <div className="max-w-2xl mx-auto bg-white border border-[#eee] rounded-lg shadow-[0_2px_8px_rgb(0_0_0/0.06)] p-12">
          <div className="mb-8">
            <h2 className="text-2xl font-bold text-[#1a1a2e] m-0 mb-2">Create a Free Account</h2>
            <p className="text-[#666] text-base m-0">While you're waiting to hear from us, why not create a free account to try out our APIs?</p>
          </div>
          <CreateAccountForm initialData={initialData ?? undefined}/>
        </div>
      </section>
    </PageLayout>
  );
}
